export default "__VITE_ASSET__Cscpvdql__"